export interface FilterState {
  genre: string;
  region: string;
  year: string;
  sort: string;
}

interface FilterPanelProps {
  filters: FilterState;
  genres: string[];
  regions: string[];
  years: string[];
  sorts: { value: string; label: string }[];
  onChange: (patch: Partial<FilterState>) => void;
  onReset: () => void;
}

const ALL = "全部";

function Group({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="mb-6 last:mb-0">
      <h3 className="text-sm font-semibold text-foreground-950 mb-3 flex items-center gap-1.5">
        <span className="w-1 h-3.5 rounded-full bg-accent-500"></span>
        {title}
      </h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = value === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onSelect(opt)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  filters,
  genres,
  regions,
  years,
  sorts,
  onChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-base font-bold text-foreground-950 font-heading flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs font-medium text-foreground-500 hover:text-accent-600 inline-flex items-center gap-1 whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <Group
        title="类型"
        options={[ALL, ...genres]}
        value={filters.genre}
        onSelect={(v) => onChange({ genre: v })}
      />
      <Group
        title="地区"
        options={[ALL, ...regions]}
        value={filters.region}
        onSelect={(v) => onChange({ region: v })}
      />
      <Group
        title="年份"
        options={[ALL, ...years]}
        value={filters.year}
        onSelect={(v) => onChange({ year: v })}
      />
      <Group
        title="排序"
        options={sorts.map((s) => s.label)}
        value={sorts.find((s) => s.value === filters.sort)?.label ?? sorts[0].label}
        onSelect={(label) => {
          const target = sorts.find((s) => s.label === label);
          if (target) onChange({ sort: target.value });
        }}
      />
    </div>
  );
}